export default {
      id: "icon--tiktok-usage",
      viewBox: "0 0 22.245 26",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--tiktok-usage",
      toString: function () {
        return this.url;
      }
    }